import { Injectable, signal } from '@angular/core';
import { italian } from './static/locales/italian';
import { english } from './static/locales/english';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {
  locale = signal(italian);

  constructor() {
    const currentLocale = localStorage.getItem('locale');
    if (!currentLocale) {
      this.setLocale(italian);
    } else {
      if (currentLocale === 'italian') {
        this.setLocale(italian);
      } else {
        this.setLocale(english);
      }
    }
  }

  getLanguage = () => {
    if (this.locale() === italian) {
      return 'italian';
    } else {
      return 'english';
    }
  };

  setLocale = (locale: any) => {
    this.locale.set(locale);
    localStorage.setItem('locale', locale === italian ? 'italian' : 'english');
  };

  switchLocale = () => {
    if (this.locale() === italian) {
      this.setLocale(english);
    } else {
      this.setLocale(italian);
    }
  };

  // Common localized messages
  getSelectCompanyMessage = (context?: 'calculations' | 'invites', hasCompanies: boolean = true): string => {
    const isEnglish = this.getLanguage() === 'english';

    // If no companies exist, show create company message
    if (!hasCompanies) {
      if (context === 'calculations') {
        return isEnglish
          ? 'Please create a company first to start calculations.'
          : 'Crea prima un\'azienda per iniziare i calcoli.';
      }
      if (context === 'invites') {
        return isEnglish
          ? 'Please create a company first to generate invite links.'
          : 'Crea prima un\'azienda per generare link di invito.';
      }
      return isEnglish
        ? 'Please create a company first.'
        : 'Crea prima un\'azienda.';
    }

    // If companies exist, show select company message
    if (context === 'calculations') {
      return isEnglish
        ? 'Please select a company from the sidebar to start calculations.'
        : 'Seleziona un\'azienda dalla barra laterale per iniziare i calcoli.';
    }

    if (context === 'invites') {
      return isEnglish
        ? 'Please select a company from the sidebar to generate invite links.'
        : 'Seleziona un\'azienda dalla barra laterale per generare link di invito.';
    }

    // Default message
    return isEnglish
      ? 'Please select a company from the sidebar.'
      : 'Seleziona un\'azienda dalla barra laterale.';
  };
}
